export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أعمدة متنازع عليها"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعادة ضبط"])}
}